import { QueryFunctionContext, useQuery, UseQueryResult } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';
import { stringifyQuery } from 'utils/query';

export interface ILeaveRequestCalendarData {
  date_range?: string;
  search?: string;
  sort?: string;
  category_ids?: string;
  user_ids?: string;
  is_approve?: '1' | '0';
  is_reject?: '1' | '0';
}

export const fetchLeaveRequestCalendarData = (
  searchQuery: ILeaveRequestCalendarData,
  signal: AbortSignal | undefined
) => {
  const stringifiedQuery = stringifyQuery(searchQuery);
  const newEndpoints = endpoints.timeOff.calendar + '?' + stringifiedQuery;

  return http().get(newEndpoints, { signal: signal });
};

export function useFetchLeaveRequestCalendarData(
  searchQuery: ILeaveRequestCalendarData,
  options?: any
): UseQueryResult<any> {
  return useQuery({
    queryKey: ['fetchLeaveRequestCalendarData', searchQuery],
    queryFn: ({ signal }: QueryFunctionContext) => fetchLeaveRequestCalendarData(searchQuery, signal),
    ...options,
  });
}
